<mat-form-field appearance="outline">
  <mat-label>{{ 'monthAndYear' | translate }}</mat-label>
  <input matInput [matDatepicker]="dp" [formControl]="control" />
  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker
    #dp
    startView="multi-year"
    panelClass="example-month-picker"
    (monthSelected)="setMonthAndYear($event, dp)"
  >
  </mat-datepicker>
</mat-form-field>
